export function fileSize(val){
  var returnData = 0;
  if(!val){
    return '-';
  }
  if (val > 0){
    if (val > 1024*1024*1024){
        let G = val/(1024*1024*1024);
        // G = this.fomatFloat(G,2);
        G = Math.round(G*Math.pow(10, 2))/Math.pow(10, 2);  
        returnData = G + 'G';
    }else if (val > 1024*1024){
        let M = val/(1024*1024);
        // M = this.fomatFloat(M,2);
        M = Math.round(M*Math.pow(10, 2))/Math.pow(10, 2);
        returnData = M + 'M';
    }else if (val > 1024){
        let K = val/(1024);
        // K = this.fomatFloat(K,2);
        K = Math.round(K*Math.pow(10, 2))/Math.pow(10, 2);
        returnData = K + 'K';
    }else {
      returnData = val + 'B';
    }
  }
  return returnData;
}


// WEBPACK FOOTER //
// ./src/utils/filters.js